export const ACTIONABLE_TYPES = {
  piProject: "pi_project",
  piPhases: "pi_phases",
  piTask: "pi_task",
};
